var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",class:[
		_vm.$s.Button,
		_vm.$s[("variant_" + _vm.resolvedVariant)],
		_vm.$s[("size_" + _vm.adjustedSize)],
		_vm.$s[("shape_" + _vm.resolvedShape)],
		_vm.$s[("align_" + _vm.resolvedAlign)],
		( _obj = {}, _obj[_vm.$s.fullWidth] = _vm.resolvedFullWidth, _obj[_vm.$s.iconButton] = _vm.isSingleChild() && !_vm.resolvedFullWidth, _obj[_vm.$s.loading] = _vm.loading, _obj ) ],style:(_vm.style),attrs:{"type":_vm.type,"disabled":_vm.isDisabled,"role":_vm.tag === 'a' ? 'button' : undefined,"aria-disabled":_vm.isDisabled ? 'true' : undefined,"aria-label":_vm.ariaLabel,"aria-pressed":_vm.pressed !== undefined ? String(_vm.pressed) : undefined}},'component',_vm.$attrs,false),_vm.$listeners),[(_vm.loading)?_c('m-loading',{class:_vm.$s.Loading}):_vm._e(),_vm._v(" "),_c('span',{class:[
			_vm.$s.MainText,
			( _obj$1 = {}, _obj$1[_vm.$s.TruncateText] = !_vm.isSingleChild(), _obj$1 )
		]},[_vm._t("default")],2),_vm._v(" "),(_vm.$scopedSlots.information)?_c('span',{class:[_vm.$s.InformationText, _vm.$s.TruncateText]},[_vm._t("information")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }